export default "__VITE_ASSET__B8q4cqtY__"